<template>
  <footer class="footer" >
    <div class="wrap2 footer-txt" v-if="description==''">
      <p>
        <img width="11px" src="../assets/img/ico_safe.png">
        <span>版权所有 Copyright 2009-{{year}} 皖公网安备 34019202000074号 增值电信业务经营许可证：皖B2-20170075</span>
      </p>
    </div>
    <div class="wrap2 footer-txt" v-else v-html="description"></div>
  </footer>

</template>

<script>
let myDate = new Date()
const year = myDate.getFullYear()
// 公有的底部区域
export default {
  name: 'loginfooter',
  props: ['description']
}
</script>

<style scoped>

</style>